import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const blockProps = useBlockProps.save({
    className: 'wp-block-puroclean-big-card'
  });

  return (
    <div {...blockProps}>
      <div className="big-card-container" data-big-card>
        <InnerBlocks.Content />
      </div>
    </div>
  );
}
